import BasicValidation from 'components/components/common/BasicValidation';
import TransHelper from 'components/common/translations/TransHelper';

export default class FlightsValidation extends BasicValidation {
  constructor(props) {
    super();
    this.props = props;
  }

  trans = (key,pref  = "content.bookingStep2.errors.flight") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  isDepartureFlightValid() {
    return (this.props.departureFlight && this.props.departureFlight.id);
  }

  isReturnFlightValid() {
    if (this.props.endDate.value) {
      return (this.props.returnFlight && this.props.returnFlight.id);
    } else {
      return true;
    }
  }

  getFieldsErrors() {
    var hash = {};
    if (!this.isDepartureFlightValid()) {
      hash['departure'] = this.trans('departure');
    }
    if (!this.isReturnFlightValid()) {
      hash['return'] =  this.trans('return');
    }
    return hash;
  }

  isValidForm() {
    return this.isDepartureFlightValid() && this.isReturnFlightValid();
  }
}
